module.exports = { "default": require("core-js/library/fn/symbol/to-primitive"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/symbol/to-primitive.js
// module id = 158
// module chunks = 0